import { getSessionToken } from "../lib/sessionToken";
/**
 * Decodes a JWT token and returns the parsed payload
 * @param {string} token - The JWT token to decode
 * @returns {object|null} - The decoded payload or null if invalid
 */
const decodeJWT = (token) => {
  try {
    // JWT has 3 parts separated by dots: header.payload.signature
    const parts = token.split('.');

    if (parts.length !== 3) {
      console.error('Invalid JWT format');
      return null;
    }

    // Decode the payload (second part)
    const payload = parts[1];

    // Add padding if necessary for base64 decoding
    const paddedPayload = payload + '='.repeat((4 - payload.length % 4) % 4);

    // Decode from base64 and parse JSON
    const decodedPayload = JSON.parse(atob(paddedPayload));

    return decodedPayload;
  } catch (error) {
    console.error('Error decoding JWT:', error);
    return null;
  }
};

/**
 * Get the provider identifier from a token response
 * @param {object} tokenData - The complete token response from VA
 * @returns {string|null} - The fediamsecid/secid or null if not found
 */
export const getFediamsecid = (tokenData) => {
  try {
    const decodedIdToken = decodeJWT(tokenData.id_token);
    return decodedIdToken
      ? decodedIdToken.fediamsecid || decodedIdToken.secid || null
      : null;
  } catch (error) {
    console.error('Error getting fediamsecid:', error);
    return null;
  }
};

export const getVAAccessToken = async () => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/va-access-token`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        token: getSessionToken(),
      },
    });

    if (!res.ok) {
      throw new Error("Failed to fetch VA access token");
    }

    const data = await res.json();
    return data; // Return the entire token response
  } catch (error) {
    console.error("Error fetching VA access token:", error);
    throw error;
  }
};